import { render, staticRenderFns } from "./ArticleInfoPage.vue?vue&type=template&id=5c1cab6f&scoped=true"
import script from "./ArticleInfoPage.vue?vue&type=script&lang=js"
export * from "./ArticleInfoPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleInfoPage.vue?vue&type=style&index=0&id=5c1cab6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1cab6f",
  null
  
)

export default component.exports